module.exports = __webpack_public_path__ + "img/2.150809ec.png";